import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  classList: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string,
  target: PropTypes.string
};
function WrapperComponent(_ref) {
  var children = _ref.children,
    classList = _ref.classList,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    size = _ref.size;
  var productImageClasses = "product-image ".concat(classList);
  if (href !== '') return /*#__PURE__*/React__default.createElement("a", {
    className: "".concat(productImageClasses, " product-image-link"),
    href: href,
    target: target,
    "data-size": size
  }, children);
  if (onClick) return /*#__PURE__*/React__default.createElement("button", {
    className: "".concat(productImageClasses, " product-image-button"),
    onClick: onClick,
    "data-size": size
  }, children);
  return /*#__PURE__*/React__default.createElement("div", {
    className: productImageClasses,
    "data-testid": "product-image-wrapper",
    "data-size": size
  }, children);
}
WrapperComponent.propTypes = propTypes;

export { WrapperComponent as default };
//# sourceMappingURL=WrapperComponent.js.map
